import { css, DefaultTheme } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { PageName } from '~/core/enums';
import { gameLinksSharedStyle } from '~/core/tableColumns/scheduleTableColumns/columnStyles';
import { centeredFlex } from '~/core/tableColumns/scheduleTableColumns/styles';

import { SIZES } from './styles';

/**
 * Network and Game Winner Styling
 */
export const gameLinksHeaderStyle = (theme: DefaultTheme) => css`
    background: ${theme.Surface.primary};
    height: ${SIZES.tableHeader.cellHeight}px;
    min-width: ${SIZES.gameLinks.iconSize}px;
    max-width: ${SIZES.gameLinks.iconSize}px;
    width: ${SIZES.gameLinks.iconSize}px;

    ${BaseStyle.Mixins.screenSizes.large} {
        height: initial;
    }

    ${gameLinksSharedStyle(theme, PageName.Schedule)};
`;

/**
 * Game Winners
 */
export const gameWinnersColumnStyle = css`
    ${BaseStyle.Mixins.fontStyles.desktop.body2};
    order: 4;
`;

/**
 * More Styling
 */
export const eventColumnStyle = css`
    order: 5;

    ${BaseStyle.Mixins.screenSizes.large} {
        order: initial;
    }
`;

export const gameScoreStyle = css`
    order: 1;
    justify-content: center;

    ${BaseStyle.Mixins.screenSizes.large} {
        order: 2;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
`;

export const gameScoreHeaderStyle = gameScoreStyle;

export const gameScoreColumnStyle = css`
    ${BaseStyle.Mixins.fontStyles.desktop.body2}
    ${gameScoreStyle}
`;

export const matchupColumnStyle = css`
    padding-right: 16px;
    order: 2;

    ${BaseStyle.Mixins.screenSizes.large} {
        align-items: center;
        display: flex;
        flex-direction: column;
        height: ${SIZES.matchup.heightLarge}px;
        justify-content: center;
        order: 1;
    }
`;

export const matchupHeaderStyle = css`
    ${centeredFlex};
    flex-direction: column;

    && {
        // Page template has 16px of padding on each side
        max-width: calc(100vw - 32px);
        min-width: 340px;

        ${BaseStyle.Mixins.screenSizes.large} {
            min-width: ${SIZES.matchup.size}px;
            max-width: ${SIZES.matchup.maxSize}px;
        }
    }
`;

export const timeColumnStyle = (isPreGame: boolean) => css`
    ${BaseStyle.Mixins.fontStyles.desktop.date};
    order: 1;
    min-height: 35px;

    ${BaseStyle.Mixins.screenSizes.large} {
        ${BaseStyle.Mixins.fontStyles.desktop.body2};
        display: ${isPreGame ? 'flex' : 'none'};
        flex-direction: row;
        justify-content: flex-start;
        order: 2;
        min-height: unset;
    }
`;

export const timeHeaderStyle = (isPreGame: boolean) => css`
    ${BaseStyle.Mixins.screenSizes.large} {
        &&.scheduleHeader {
            display: ${isPreGame ? 'flex' : 'none'};
            flex-direction: row;
            justify-content: flex-start;
        }
    }

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        &&.scheduleHeader {
            display: flex;
        }
    }
`;
